import styled from 'glamorous'
import { withRouter } from 'react-router-dom'

import { $ } from 'utils'


const Container = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: 70,
  padding: '10px 20px',
  borderBottom: '1px solid var(--borderColor)',
  backgroundColor: 'white',
  cursor: 'pointer',
  boxSizing: 'border-box',
  '&:after': {
    content: ' ',
    position: 'absolute',
    opacity: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: -1,
    border: '3px solid var(--violet)',
    transition: 'opacity ease-in 0.3s',
  },
  '&:hover:after': {
    opacity: 1,
  }
}, ({ selected }) => selected && {
  '&:after': {
    opacity: 1,
  }
})

const ListName = styled.div({
  fontWeight: 'bold'
})

const ListId = styled.div({
  color: 'var(--grey)'
})

export const ListItem = ({ history, match, location, list, tab }) => {

  const handleSelect = () => {
    history.push({
      pathname: `/list/${tab}/${list.uuid}`,
      search: location.search,
    })
  }

  return (
    $(Container, { onClick: handleSelect, selected: match.params.id === list.uuid },
      $(ListName, list.listData),
      $(ListId, list.uuid),
    )
  )
}

export default withRouter(ListItem)



// WEBPACK FOOTER //
// ./src/pages/Lists/ListItem.js